import React, { useEffect, useState } from "react";
import { useSnackbar } from "@components";
import { Modal, Card, Carousel, Image } from "antd";
import { workflowTruckById } from "../../../../../src/libs/apis";
import { WorkflowTruckI } from "../../../../../src/libs/interfaces";
import { Box } from "@mui/material";
import type { Dayjs } from "dayjs";
import laImg from "../../../../images/no-image.jpg";

interface ShowContainerPropsI {
  open: boolean;
  onClose: () => void;
  id: number;
}

const noShow = [
  "id",
  "client",
  "producer",
  "farm",
  "zone",
  "balerCode",
  "box",
  "brand",
  "container",
  "clientId",
  "producerId",
  "farmId",
  "magap",
  "boxId",
  "brandId",
  "startProcess",
  "containerArrival",
  "containerOpen",
  "startLoading",
];

interface OnePhotoI {
  src: string | number | boolean | Dayjs | null | undefined;
  alt: string;
}

export const ShowContainer = ({ open, onClose, id }: ShowContainerPropsI) => {
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState<WorkflowTruckI>({
    container: "",
  } as WorkflowTruckI);
  const [cards, setCards] = useState<OnePhotoI[]>([]);

  useEffect(() => {
    handleGetData();
  }, []);

  const handleGetData = async () => {
    try {
      const { data: dataContainer } = await workflowTruckById(id);
      if (!dataContainer) return;
      setData(dataContainer);
      const arrKeys = Object.keys(dataContainer).filter(
        (el) => !noShow.includes(el),
      ) as Array<keyof WorkflowTruckI>;

      const keysParents = arrKeys.filter((el) => el.includes("photo")) as any;

      const arrCards: OnePhotoI[] = [];
      for (const x of keysParents) {
        const src = dataContainer[x] as unknown as string;
        if (!src) continue;
        arrCards.push({
          src,
          alt: x,
        });
      }

      setCards(arrCards);

      setLoading(false);
    } catch (err: any) {
      enqueueSnackbar(err.toString(), { variant: "error" });
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <p
          style={{ color: "green" }}
        >{`FOTOS Y VIDEOS CONTENEDOR N° ${data.container}`}</p>
      }
      footer={null}
      loading={isLoading}
      open={open}
      onClose={onClose}
      onCancel={onClose}
      width={810}
      centered={true}
      zIndex={1602}
    >
      <Box
        sx={{
          overflowY: "auto",
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 1,
          width: "100%",
          minHeight: 550,
          maxHeight: 550,
          height: 550,
        }}
      >
        <Carousel
          arrows={true}
          autoplay={true}
          style={{
            minWidth: 700,
            width: 700,
            display: "flex",
            justifyContent: "center",
            height: 500,
            maxHeight: 500,
            minHeight: 500,
          }}
        >
          {cards.map((el) => (
            <Image
              alt={el.alt}
              src={el.src as string}
              fallback={laImg}
              height={500}
              width={700}
              style={{
                maxHeight: 500,
                maxWidth: 700,
              }}
            />
          ))}
        </Carousel>
      </Box>
    </Modal>
  );
};
